export default function RelativeVolumeBar({ value, max }: { value: number; max: number }) {
	const percent = max > 0 ? Math.max(0, Math.min(100, (value / max) * 100)) : 0
	return (
		<div
			className="flex h-7 w-[104px] items-end rounded-md bg-muted/40 px-1.5 py-1"
			role="img"
			aria-label={`${percent.toFixed(1)}% of the highest 7-day volume in this table`}
			title={`${percent.toFixed(1)}% of the highest 7-day volume in this table`}
		>
			<div className="h-full rounded-sm bg-gradient-to-r from-purple-600 to-blue-500" style={{ width: `${percent}%`, minWidth: percent > 0 ? 6 : 0 }} />
		</div>
	)
}
